<template>
  <div class="home-page">
    <BannerAtom :homePageTitle="bannerTitle" :homePageSubTitle="homePageSubTitle" :image="image" />

    <div class="home-page__main" v-if="!isEnglish">
      <div class="home_page__textContent">
        <p>
          Bygg- och fastighetssektorn stod 2021 för 22% av Sveriges utsläpp av växthusgaser.
          <a
            href="https://www.boverket.se/sv/om-boverket/publicerat-av-boverket/nyheter/utslapp-okar/#:~:text=Bygg%2D%20och%20fastighetssektorns%20inhemska%20utsl%C3%A4pp,med%20cirka%200%2C1%20procentenheter"
            target="_blank"
            >Utsläppen från nybyggnation ökade.</a
          >
        </p>
        <p>
          Enligt EU behöver vi minska vår klimatpåverkan med 90% till 2040 jämfört med 1990, och med 55% till 2030, Trots detta saknas fastslagna mål för
          utsläppsminskning inom byggsektorn.
        </p>
        <p>
          I Sverige är det sedan 1 januari 2022 ett krav vid nybyggnation att lämna in en klimatdeklaration som redovisar vilken påverkan på klimatet den nya
          byggnaden har. Byggutsläppslistan publicerar siffror över deklarerade utsläpp från nybyggnation i Sverige, sorterade efter projekt, kommun eller
          byggherre.
        </p>
      </div>
      <div class="links-wrapper">
        <div>
          <router-link to="/projects"><div @click="trackClick('projects')" class="links-wrapper__container">Projekt</div></router-link>
          <router-link to="/communes"><div @click="trackClick('communes')" class="links-wrapper__container">Kommuner</div></router-link>
        </div>
        <div>
          <router-link to="/builders"><div @click="trackClick('builders')" class="links-wrapper__container">Byggherrar</div></router-link>
          <router-link to="/building-types"><div @click="trackClick('buildingTypes')" class="links-wrapper__container">Byggnadstyper</div></router-link>
        </div>
      </div>
      <div class="home_page__textContent">
        <p>
          De data som publiceras här är byggherrarnas egna siffror, hämtade ur de klimatdeklarationer som lämnats in till Boverket. Byggutsläppslistan
          uppdateras löpande.
        </p>
        <p>
          Klimatdeklarationerna visar inte hela sanningen. I nuläget behöver inte alla typer av byggnader eller alla byggnadsdelar deklareras. Till exempel
          ingår inte markarbeten, installationer eller invändiga ytskikt, och industribyggnader eller byggnader för försvaret behöver inte deklareras alls. De
          verkliga utsläppen är alltså högre än de siffror vi presenterar här.
        </p>
        <p>
          Men, deklarerade utsläpp är en viktig indikation, och eftersom klimatdeklarationer är det system som finns för att följa utsläppen från byggnation i
          Sverige har vi valt att tillgängliggöra siffrorna. Syftet är att förbättra kunskapsläget, lyfta frågan om byggandets utsläpp och därigenom driva
          förändring.
          <br />
          <a href="https://www.boverket.se/sv/klimatdeklaration/" target="_blank">Mer om klimatdeklarationer</a>
        </p>
        <p>
          För en byggnads totala klimatpåverkan över tid är energiförbrukning ytterligare en stor del, och den syns inte här. Det klimatdeklarationerna
          fokuserar på är produktionsskedet.
        </p>
        <p>
          Byggutsläppslistan är skapad av <a href="https://www.architectscan.se/" target="_blank">Architects Climate Action Network (ACAN) Sverige</a> – ett
          ideellt nätverk av aktiva inom byggd miljö, som verkar för att skapa ett hållbart samhällsbyggande inom de planetära gränserna. Hemsidan är framtagen
          i samarbete med <a href="https://www.differ.se/" target="_blank">Differ</a> som stöttar initiativ kopplade till en hållbar samhällsomställning.
        </p>
      </div>
      <div class="home-page__main__share-button">
        <ShareAtom :lightTheme="false" />
      </div>
    </div>
    <div class="home-page__main" v-if="isEnglish">
      <div class="home_page__textContent">
        <p>
          In 2021, the construction and property sector accounted for 22% of Sweden's greenhouse gas emissions
          <a
            href="https://www.boverket.se/sv/om-boverket/publicerat-av-boverket/nyheter/utslapp-okar/#:~:text=Bygg%2D%20och%20fastighetssektorns%20inhemska%20utsl%C3%A4pp,med%20cirka%200%2C1%20procentenheter"
            target="_blank"
            >an increase from the previous year.</a
          >
        </p>
        <p>
          To reach the EU’s climate goals, a 55% reduction in our climate impact (compared to 1990 levels) is needed by 2030 and a 90% reduction is needed by
          2040. Despite this, there are no established targets in Sweden for emission reduction in the construction sector.
        </p>
        <p>
          Since January 1, 2022, new construction projects in Sweden are required to submit a declaration that reports their greenhouse gas emissions from the
          construction phase, also known as embodied carbon. Embodied Carbon Declared, publishes data from these climate declarations, sorted by project,
          municipality and developer.
        </p>
      </div>
      <div class="links-wrapper">
        <div>
          <router-link to="/projects"><div @click="trackClick('projects')" class="links-wrapper__container">Projects</div></router-link>
          <router-link to="/communes"><div @click="trackClick('communes')" class="links-wrapper__container">Municipalities</div></router-link>
        </div>
        <div>
          <router-link to="/builders"><div @click="trackClick('builders')" class="links-wrapper__container">Developers</div></router-link>
          <router-link to="/building-types"><div @click="trackClick('buildingTypes')" class="links-wrapper__container">Building types</div></router-link>
        </div>
      </div>
      <div class="home_page__textContent">
        <p>
          The data published here are the developers' figures, taken from climate declarations submitted to the Swedish National Board of Housing, Building and
          Planning (Boverket). The list of construction emissions is continuously updated with new projects.
        </p>
        <p>
          The climate declarations do not show the whole truth. Not all types of buildings or building parts need to be declared. For example, earthworks,
          installations, or interior finishes are not included, and industrial or defense buildings do not need to be declared at all. The energy consumption of
          a building over its lifespan is another significant part of its total emissions that is not reflected in the climate declarations. What the climate
          declarations focus on is the production stage.The real emissions from new construction are thus higher than the figures we present here.
        </p>
        <p>
          However, declared emissions are an important indicator. Since climate declarations are the system that exists to monitor emissions from construction
          in Sweden, we have chosen to make the data easily accessible. The aim is to improve the state of knowledge, raise awareness on the construction
          industry’s climate impact, and thereby drive change
          <br />
          <a href="https://www.boverket.se/sv/klimatdeklaration/" target="_blank">Read more about climate declarations (in swedish)</a>
        </p>

        <p>
          The Embodied Carbon Declared website was created by the
          <a href="https://www.architectscan.se/" target="_blank">Architects Climate Action Network (ACAN) Sweden</a> – a non-profit network of individuals
          working within the built environment, which works to create a sustainable construction sector, staying within the planetary boundaries. The website
          has been developed in collaboration with <a href="https://www.differ.se/" target="_blank">Differ</a>, which supports initiatives linked to a
          sustainable social transition
        </p>
      </div>
      <div class="home-page__main__share-button">
        <ShareAtom :lightTheme="false" />
      </div>
    </div>
  </div>
</template>

<script>
import { inject, computed, ref } from 'vue';
import ShareAtom from '../atoms/ShareAtom.vue';
import BannerAtom from '../atoms/BannerAtom.vue';
import api from '@/api/projects.js';

export default {
  name: 'HomePage',
  components: {
    ShareAtom,
    BannerAtom,
  },
  data() {
    return {
      image: require('@/assets/images/home.jpg'),
      totalEmissions: 0,
      bannerTitle: '&nbsp',
      homePageSubTitle: '',
      period: ref({ fromDate: '', toDate: '' }),
    };
  },
  setup() {
    const language = inject('language');
    const isEnglish = computed(() => language.value === 'en');

    return {
      isEnglish,
    };
  },
  methods: {
    async loadPeriod() {
      try {
        this.period.value = await api.getProjectsPeriod();
        console.log('Fetched projects period:', this.period.value);
      } catch (error) {
        console.error('Error fetching projects period:', error);
      }
    },
    async getTotalEmissions() {
      let emissions = await api.getProjects();
      emissions = emissions.reduce((acc, curr) => {
        return acc + curr.totalaUtslapp;
      }, 0);
      return emissions;
    },
    formatDate(isoDate) {
      const parts = isoDate.replace(/-0/g, '-').split('-');
      const [year, month, day] = parts;
      return `${day}/${month} ${year}`;
    },
    setBannerTitle() {
      let num = this.totalEmissions / 1000;
      num = num.toFixed(0);
      const range = `${this.formatDate(this.period.value.fromDate)} - ${this.formatDate(this.period.value.toDate)}`;

      if (this.isEnglish) {
        this.bannerTitle = `<span class="titleNumberSpan">${num}</span><span class="br">tonnes CO<span class="O2span">₂</span>e</span>`;
        this.homePageSubTitle = `Declared emissions from new construction in Sweden from ${range}`;
      } else {
        this.bannerTitle = `<span class="titleNumberSpan">${num}</span><span class="br">ton C<span class="O2span">O₂</span>e</span>`;
        this.homePageSubTitle = `Deklarerade utsläpp från nybyggnation i Sverige från ${range}`;
      }
    },
    trackClick(page) {
      if (this.$gtag) {
        this.$gtag.event('click', {
          event_category: 'navigation',
          event_label: page,
        });
      }
    },
  },
  async mounted() {
    await this.loadPeriod();
    this.totalEmissions = await this.getTotalEmissions();
    this.setBannerTitle();
  },
};
</script>

<style scoped>
.home-page {
  background-color: black;
}
.home-page__main {
  padding: 20px;
  margin-top: -5px;
}
.home_page__textContent {
  max-width: 500px;
  font-size: 17px;
  margin: 20px auto 20px auto;
  letter-spacing: 1.2px;
}
p {
  font-family: 'bred', sans-serif;
  line-height: 1.2;
}
.links-wrapper {
  max-width: 500px;
  margin: 50px auto;
}
.links-wrapper a {
  text-decoration: none;
  letter-spacing: 1px;
}
.links-wrapper__container {
  border-radius: 1px;
  font-size: 20px;
  font-family: 'fet', sans-serif;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 40px 20px;
  margin: 10px 0;
  text-align: center;
}
.links-wrapper__container:hover {
  background-color: #00279c;
  border-color: #00279c;
}
.links-wrapper__container:active {
  background-color: #00279c;
  border-color: #00279c;
}
.home-page__main__share-button {
  max-width: 500px;
  margin: auto;
}

@media all and (min-width: 1024px) {
  .home-page__main {
    float: left;
    padding: 40px;
    margin-left: 5px;
  }
  .home_page__textContent {
    max-width: 800px;
    font-size: 20px;
    margin: 10px auto 20px auto;
  }
  .links-wrapper {
    max-width: 100%;
    justify-content: center;
  }
  .links-wrapper__container {
    display: inline-block;
    width: 246.5px;
    margin-right: 20px;
  }
  .links-wrapper {
    margin: 20px auto;
  }
  .home-page__main__share-button {
    max-width: 800px;
  }
  p {
    font-size: 20px;
  }
}
</style>

<!-- Global för att hitta v-html renderad text -->
<style>
.titleNumberSpan {
  word-spacing: -10px;
  margin-right: 0.5ch;
  font-family: 'fet', sans-serif;
}

.O2span {
  letter-spacing: 0;
  font-family: 'fet', sans-serif;
}

.br {
  letter-spacing: 1px;
  font-family: 'fet', sans-serif;
}

@media all and (max-width: 600px) {
  .br {
    display: block;
    letter-spacing: 1px;
  }
  .titleNumberSpan {
    margin-right: 0;
  }
}
</style>
